import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/employees/create')({
  staticData: { hideShell: true },
});
